import { render, staticRenderFns } from "./ProfessionalExceptions.vue?vue&type=template&id=238d36cc"
import script from "./ProfessionalExceptions.vue?vue&type=script&lang=js"
export * from "./ProfessionalExceptions.vue?vue&type=script&lang=js"
import style0 from "./ProfessionalExceptions.vue?vue&type=style&index=0&id=238d36cc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports